import {fromJS} from "immutable";
import {getGeoType} from "../../utils/getGeoType";
import {dataLayer, dataLayerLineString, dataLayerPoint} from "./loadMapStyle";
import {Reducer} from "redux";
import {IApplicationState} from "../types";

const selectFeature: Reducer<IApplicationState['map']> = (state, action) => {
    const {feature} = action.payload;
    let highlightedFeatures;
    let mapStyle = state?.mapStyle!;

    highlightedFeatures = fromJS([]);
    mapStyle = mapStyle?.setIn(['sources', dataLayerPoint.source, 'data', 'features'], highlightedFeatures)
        .setIn(['sources', dataLayerLineString.source, 'data', 'features'], highlightedFeatures)
        .setIn(['sources', dataLayer.source, 'data', 'features'], highlightedFeatures);

    if (feature) {
        let geoType;
        if (feature.properties?.type) {
            highlightedFeatures = mapStyle
                .getIn(['sources', feature.properties?.type, 'data', 'features'])
                .filter((f: any) => f.getIn(['properties', 'fullUid']) === feature.properties?.fullUid);

            geoType = highlightedFeatures.getIn([0, 'properties', 'geoType']);
        }else {
            geoType = getGeoType(feature);
        }

        if (highlightedFeatures.size === 0) {
            highlightedFeatures = highlightedFeatures.push(feature);
        }

        switch (geoType) {
            case 'Point':
                mapStyle = mapStyle
                    .setIn(['sources', dataLayerPoint.source, 'data', 'features'], highlightedFeatures);
                break;
            case 'Line':
                mapStyle = mapStyle
                    .setIn(['sources', dataLayerLineString.source, 'data', 'features'], highlightedFeatures);
                break;
            case 'Polygon':
            default:
                mapStyle = mapStyle
                    .setIn(['sources', dataLayer.source, 'data', 'features'], highlightedFeatures);
        }
    }


    return {...state, mapStyle} as IApplicationState['map'];
}

export { selectFeature };
